import { render } from "./contactNotes.vue?vue&type=template&id=57272be6"
import script from "./contactNotes.vue?vue&type=script&lang=js"
export * from "./contactNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__